import { useState } from 'react';
import { FormField, FormFieldOption, ValidationRules } from '../..';
import { FormFieldType, FormFieldValue, Validator } from '../../types';

export function useFormFieldEffect(
  name: string,
  type: FormFieldType,
  validators?: Validator[],
  rules?: ValidationRules,
  initialValue: FormFieldValue = null,
  choices?: FormFieldOption[],
  phrase?: string
): FormField {
  const initialClean =
    !initialValue || initialValue === '' || initialValue === [];

  const initialValid = !!(initialValue && !initialClean);

  const [isClean, setIsClean] = useState(initialClean);
  const [isValid, setIsValid] = useState(initialValid);
  const [isBlurred, setIsBlurred] = useState(true);
  const [errors, setErrors] = useState([] as string[]);
  const [value, setValue] = useState(initialValue as FormFieldValue);

  const updateValue = (updatedValue: FormFieldValue) => {
    switch (type) {
      case 'checkbox': {
        const currentValue = value !== null ? (value as number[]) : [];
        const checkboxValue = updatedValue as number;
        const valueIndex = currentValue.indexOf(checkboxValue);

        if (valueIndex > -1) {
          currentValue.splice(valueIndex, 1);
        } else {
          currentValue.push(checkboxValue);
        }

        setValue(currentValue);
        break;
      }
      default: {
        setValue(updatedValue);
      }
    }
  };

  const onChange = async (
    formFieldValue: FormFieldValue,
    kin?: FormFieldValue
  ) => {
    updateValue(formFieldValue);
    let valid = true;
    let errors: string[] = [];

    if (validators && validators.length > 0) {
      const validationRules = kin ? { ...rules, kin } : rules;

      await Promise.all(
        validators.map(async (validate) => {
          const result = await validate(formFieldValue, validationRules);
          if (!result.valid) {
            valid = false;
            errors = [...errors, ...result.errors];
          }

          return result;
        })
      );

      setIsValid(valid);
      setErrors(errors);
    } else {
      setIsValid(valid);
    }
  };

  const onBlur = () => {
    setIsBlurred(true);
  };

  const onFocus = () => {
    setIsBlurred(false);
    setIsClean(false);
  };

  const doReset = (clean = false) => {
    setIsClean(true);
    setIsValid(false);
    setIsBlurred(false);
    setErrors([]);
    setValue(clean ? null : initialValue);
  };

  if (validators && validators.length <= 0 && !isValid) {
    setIsValid(true);
  }

  const formField = {
    type,
    name,
    phrase,
    isClean,
    isBlurred,
    isValid,
    errors,
    value,
    choices,
    validators,
    onChange,
    onBlur,
    onFocus,
    doReset,
  };
  return formField;
}
